import Vue from 'vue'
import { latLng, latLngBounds, CRS } from 'leaflet'
import Zones from '@/api/services/objects/zones'
const getDefaultState = () => ({
  tooltipOptions: {
    permanent: true,
    interactive: true
  },
  clusterOptions: {
    spiderLegPolylineOptions: { weight: 1.5, color: '#000', opacity: 0.5 },
    removeOutsideVisibleBounds: true,
    showCoverageOnHover: !1
  },
  map: {
    zoom: Vue.ls.get('mapZoom', 10, Number),
    center: latLng(Vue.ls.get('mapCenter', {lat: 55.752526, lng: 37.620012, alt: 'Moscow'}, Object)),
    maxBounds: latLngBounds([
      latLng(-90, -180),
      latLng(90, 180)
    ]),
    zones: [],
    tileLayer: {
      yandex: {
        url: 'https://vec{s}.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU',
        layerOptions: {
          noWrap: true,
          subdomains: ['01', '02', '03', '04']
        },
        attribution: '<a href="//leafletjs.com/">Leaflet</a> | &copy; Яндекс <a href="https://yandex.ru/legal/maps_termsofuse/?lang=ru">Условия использования</a>'
      },
      google: {
        layerOptions: {
          noWrap: true,
          styles: [
            {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
            {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
            {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
            {
              featureType: 'administrative.locality',
              elementType: 'labels.text.fill',
              stylers: [{color: '#d59563'}]
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [{color: '#999999'}]
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [{color: '#263c3f'}]
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text.fill',
              stylers: [{color: '#6b9a76'}]
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [{color: '#38414e'}]
            },
            {
              featureType: 'road',
              elementType: 'geometry.stroke',
              stylers: [{color: '#212a37'}]
            },
            {
              featureType: 'road',
              elementType: 'labels.text.fill',
              stylers: [{color: '#9ca5b3'}]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [{color: '#746855'}]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [{color: '#1f2835'}]
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.fill',
              stylers: [{color: '#f3d19c'}]
            },
            {
              featureType: 'transit',
              elementType: 'geometry',
              stylers: [{color: '#2f3948'}]
            },
            {
              featureType: 'transit.station',
              elementType: 'labels.text.fill',
              stylers: [{color: '#d59563'}]
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [{color: '#17263c'}]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [{color: '#515c6d'}]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.stroke',
              stylers: [{color: '#17263c'}]
            }
          ],
          type: 'roadmap'
        },
        attribution: ''
      },
      google_terrain: {
        layerOptions: {
          noWrap: true,
          type: 'terrain'
        },
        attribution: ''
      },
      wiki: {
        url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
        layerOptions: {
          noWrap: true
        },
        attribution: '<a href="//leafletjs.com/">Leaflet</a> | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }
    },
    currentTile: Vue.ls.get('currentTile', 'wiki', String),
    mainIcon: {
      lbs: 'https://panel-scannergps.com/img/markers/arrow-red.svg',
      gps: 'https://panel-scannergps.com/img/markers/arrow-black.svg'
    },
    mapOptions: {
      minZoom: 3,
      zoomControl: true,
      attributionControl: false,
      zoomSnap: true
    },
    objectOptions: {
      ...Vue.ls.get('objectOptions', {
        visible: true,
        history_points: false
      }, Object),
      geozones: false
    },
    zoomPosition: 'topright',
    positions: ['topleft', 'topright', 'bottomleft', 'bottomright'],
    attributionPosition: 'bottomright',
    layersPosition: 'topright',
    zIndex: 9000,
    currentDevice: Vue.ls.get('device', 0, Number),
    currentGroup: Vue.ls.get('group', 0, Number)
  }
})

export default {
  state: getDefaultState(),
  getters: {
    getMap: state => state.map,
    getCRS: state => state.map.currentTile === 'yandex' ? CRS.EPSG3395 : CRS.EPSG3857,
    getTooltipOptions: state => state.tooltipOptions,
    getClusterOptions: state => state.clusterOptions,
    getCurrentDevice: state => state.map.currentDevice,
    getCurrentGroup: state => state.map.currentGroup
  },
  mutations: {
    resetMapState (state) {
      Object.assign(state, getDefaultState())
    },
    setMapParams (state, payload) {
      state.map[payload.name] = payload.value
    }
  },
  actions: {
    getGeoZone ({state}, zoneLink) {
      return new Promise(resolve => {
        Zones.getGeoZone(zoneLink).then(data => {
          resolve(data)
        })
      })
    },
    setGeoZonesData ({commit, state, dispatch}, zones) {
      if (zones.length) {
        zones.reduce((acc, curr, index) => {
          return acc.then(() => {
            return dispatch('getGeoZone', curr.zone_link).then(data => {
              zones[index].data = data
              return data
            })
          })
        }, Promise.resolve()).then(e => {
          commit('setMapParams', {
            name: 'zones',
            value: zones
          })
        })
      }
    },
    getGeoZones ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        if (payload && !state.map.zones.length) {
          Zones.getGeoZones().then(data => {
            resolve(data)
          })
        } else {
          reject(payload)
        }
      })
    },
    setMapParams ({commit}, payload) {
      commit('setMapParams', payload)
      if (payload.updateLs) {
        Vue.ls.set(payload.name, payload.value)
      }
    },
    setCurrentDevice ({state, commit}, data) {
      return new Promise(resolve => {
        state.map.currentDevice = parseInt(data.idx)
        state.map.currentGroup = parseInt(data.idxg)
        if (!data.noHistory) {
          commit('addToHistory', {
            id: data.id,
            group_id: data.group_id
          })
        }
        Vue.ls.set('device', state.map.currentDevice)
        Vue.ls.set('group', state.map.currentGroup)
        resolve()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/map.js